import styled from "@emotion/styled"
import React from "react"
import heroImage from "../../content/assets/hero.jpg"

const Hero = styled.section`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  min-height: 14rem;
  padding: 2rem 1.6rem;
  background-color: #101820;

  @media (min-width: 760px) {
    min-height: 25rem;
  }
`

const HeroImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 160%;
  min-width: 160%;
  max-width: none;
  height: 100%;
  margin-left: -50%;
  object-fit: cover;
  object-position: center center;
  margin-bottom: 0;

  @media (min-width: 760px) {
    height: auto;
    min-height: 100%;
    width: 100%;
    min-width: 100%;
    margin-left: 0;
  }
`

const HeroOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    rgba(16, 24, 32, 0.96) 0%,
    rgba(16, 24, 32, 0.82) 36%,
    rgba(16, 24, 32, 0.34) 54%,
    rgba(16, 24, 32, 0) 68%
  );
`

const HeroInner = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 66rem;
  margin: 0 auto;
`

const HeroTitle = styled.h1`
  max-width: 36rem;
  margin-bottom: 0;
  color: #ffffff;
  font-family: "Lato", sans-serif;
  font-size: 3rem;
  font-weight: 700;
  line-height: 0.95;

  @media (min-width: 760px) {
    font-size: 4rem;
  }
`

const PageHero = ({ title }) => {
  return (
    <Hero>
      <HeroImage src={heroImage} alt="" aria-hidden="true" />
      <HeroOverlay />
      <HeroInner>
        <HeroTitle>{title}</HeroTitle>
      </HeroInner>
    </Hero>
  )
}

export default PageHero
